import api from "./apiClient";
import API_ENDPOINTS from "../config/apiEndpoints";

const unwrapDataSet = (response) => response?.data || response || {};

export const fetchOrganizationSetup = async (organizationId, createdBy) => {
  const response = await api.post(API_ENDPOINTS.ORGANIZATION.SETUP_ACTIVITY, {
    ActionType: "GetSetup",
    OrganizationId: organizationId,
    CreatedBy: createdBy,
  });
  return response;
};

export const saveOrganizationSetup = async (payload) => {
  const response = await api.post(API_ENDPOINTS.ORGANIZATION.SETUP_ACTIVITY, {
    ActionType: "UpdateSetup",
    ...payload,
  });
  return response;
};

export const deleteOrganizationLocation = async ({
  organizationId,
  createdBy,
  locationId,
}) => {
  const response = await api.post(API_ENDPOINTS.ORGANIZATION.LOCATION_ACTIVITY, {
    ActionType: "Delete",
    OrganizationId: organizationId,
    CreatedBy: createdBy,
    LocationId: locationId,
  });
  return response;
};

export const parseOrganizationSetupResponse = (response) => {
  const data = unwrapDataSet(response);
  const setupRow = Array.isArray(data.SuccessStory) ? data.SuccessStory[0] : null;
  const locations = Array.isArray(data.OrgLocations) ? data.OrgLocations : [];
  const timeZones = Array.isArray(data.TimeZones) ? data.TimeZones : [];
  const countries = Array.isArray(data.Countries) ? data.Countries : [];
  const countryTimeZones = Array.isArray(data.CountryTimeZones)
    ? data.CountryTimeZones
    : [];
  return {
    setupRow,
    locations,
    timeZones,
    countries,
    countryTimeZones,
  };
};

export const parseSetupSaveResult = (response) => {
  const data = unwrapDataSet(response);
  const row = Array.isArray(data.SuccessStory) ? data.SuccessStory[0] : null;
  return {
    success: Number(row?.Success) === 1,
    message: row?.MSG || response?.message || "Could not save organisation setup.",
  };
};
